var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGarbageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.5 64C50.1731 64 64.5 49.6731 64.5 32C64.5 14.3269 50.1731 0 32.5 0C14.8269 0 0.5 14.3269 0.5 32C0.5 49.6731 14.8269 64 32.5 64Z",
    fill: "#E50B20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3002 16L27.7002 17.6H21.3002C20.417 17.6 19.7002 18.3168 19.7002 19.2C19.7002 20.0832 20.417 20.8 21.3002 20.8H24.5002H40.5002H43.7002C44.5834 20.8 45.3002 20.0832 45.3002 19.2C45.3002 18.3168 44.5834 17.6 43.7002 17.6H37.3002L35.7002 16H29.3002ZM21.3002 24V44.8C21.3002 46.568 22.7322 48 24.5002 48H40.5002C42.2682 48 43.7002 46.568 43.7002 44.8V24H21.3002Z",
    fill: "#E50B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarbageIcon);
export default __webpack_public_path__ + "static/media/garbage-icon.a3abe79b5895c55dda52ae3b5aa0043f.svg";
export { ForwardRef as ReactComponent };